var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 15.5C3.015 15.5 2.68542 15.3531 2.41125 15.0594C2.13708 14.7656 2 14.4125 2 14V5C2 4.5875 2.13708 4.23438 2.41125 3.94063C2.68542 3.64687 3.015 3.5 3.4 3.5H7.6L9 5H14.6C14.985 5 15.3146 5.14688 15.5887 5.44063C15.8629 5.73438 16 6.0875 16 6.5V14C16 14.4125 15.8629 14.7656 15.5887 15.0594C15.3146 15.3531 14.985 15.5 14.6 15.5H3.4Z",
    fill: "#7A7F89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledFolder);
export default __webpack_public_path__ + "static/media/disabled_folder.ea139415009ace410a51d4de96bd329a.svg";
export { ForwardRef as ReactComponent };